<template lang="pug">
div(v-if="hasTags")
  span(v-for="(tag, index) in visibleTags")
    v-chip(
      :key="index"
      label
      small
      disabled
    )
      span.text-truncate(
        :id="`tag-anchor-${contactKey}-${index}`"
        @mouseover="showTooltip(index, true)"
        @mouseleave="showTooltip(index, false)"
      ) {{ tag }}
        v-tooltip(
          v-if="showTooltips[index]"
          :activator="`#tag-anchor-${contactKey}-${index}`"
          :value="showTooltips[index]"
          bottom
          )
          span.tooltip-tag {{ tag }}

  a.grey--text.caption.more-tags(
    v-if="hasInvisibleTags"
    :id="`more-tag-anchor-${contactKey}`"
    @mouseover="showMoreTooltip = true"
    @mouseleave="showMoreTooltip = false"
    )
    | + {{ invisibleTags.length }} more
    v-tooltip(
      v-if="showMoreTooltip"
      :activator="`#more-tag-anchor-${contactKey}`"
      :value="showMoreTooltip"
      bottom
      max-width="300px"
      )
      .tooltip-tag(v-for="(tag, index) in invisibleTags" :key="index") {{ tag }}
</template>

<script>
const MAX_TAGS_VISIBLE_INLINE = 2;
const TAG_DELIMITER = '^';

export default {
  props: {
    data: {
      type: [String, Array],
    },
    contactKey: {
      required: true,
    }
  },

  data() {
    return {
      showTooltips: new Array(MAX_TAGS_VISIBLE_INLINE).fill(false),
      showMoreTooltip: false,
    }
  },

  // Test - since the component is not being removed, just updated
  // we need to reset the show values on contact change
  watch: {
    contactKey(value) {
      this.showTooltips = new Array(MAX_TAGS_VISIBLE_INLINE).fill(false);
      this.showMoreTooltip = false;
    }
  },

  computed: {
    tags() {
      if (!this.data) return [];
      return Array.isArray(this.data) ?
        this.data.map(tag => tag.content) :
        this.data.split(TAG_DELIMITER).filter(tag => !!tag);
    },
    hasTags() {
      return !!this.tags.length;
    },
    visibleTags() {
      return this.tags.slice(0, MAX_TAGS_VISIBLE_INLINE);
    },
    hasInvisibleTags() {
      return this.tags.length > MAX_TAGS_VISIBLE_INLINE;
    },
    invisibleTags() {
      return this.tags.slice(MAX_TAGS_VISIBLE_INLINE);
    },
  },

  methods: {
    showTooltip(index, value) {
      this.$set(this.showTooltips, index, value);
    },
  },

};
</script>

<style scoped lang="scss">
.tags {
  width: 250px;
}

.more-tags {
  vertical-align: middle;
}

.text-truncate {
  max-width: 100px;
}
</style>
